var render = function render(){var _vm=this,_c=_vm._self._c;return _c('th',{attrs:{"scope":"col"}},[_c('div',{staticClass:"d-flex align-items-center white-space-none",class:_vm.alignment === 'right' ? 'justify-content-end' : ''},[_c('span',[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),(_vm.tooltipText != '')?_c('product-variants-table-tooltip',{attrs:{"tooltip-text":_vm.getProductPageTranslations[
          'ProductDetail.VariantsTable.Headings.SafetyTooltip'
        ]}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }